<template>
  <wrapper>
    <div class="flex flex-col w-full">
      <p class="w-full mb-2 font-bold">
        Articles to be imported:
        {{ new Intl.NumberFormat().format(articleDataLength) }}
      </p>
    </div>
    <expandabel-table
      :text="'Articles Data:'"
      :columnsToNotSort="columnsToNotSort"
      :headers="headers"
      :data="articleData"
      :useSearch="false"
    >
      <template v-slot:column="{ column, child }">
        {{ child[column] }}
      </template>
      <template v-slot:child="{ child }">
        <div class="flex flex-col w-full">
          <div class="flex p-4 rounded-lg bg-primary-light">
            <div class="flex flex-col flex-1">
              <span class="text-xs font-bold">External Identifier</span>
              <span class="text-gray-light">{{
                child.externalIdentifier
              }}</span>
            </div>
          </div>
          <p class="w-full mb-2 font-bold">Group data</p>
          <div class="flex p-4 rounded-lg bg-primary-light">
            <div class="flex flex-col flex-1">
              <span class="text-xs font-bold">Group Strategy</span>
              <span class="text-gray-light">{{ child.groupStrategy }}</span>
            </div>
            <div class="flex flex-col flex-1">
              <span class="text-xs font-bold">Group Names</span>
              <span class="text-gray-light">{{ child.groupNames }}</span>
            </div>
          </div>
          <div class="flex flex-col w-full mt-4">
            <div
              class="flex items-center article-data-header"
              v-on:click="child.showData = !child.showData"
            >
              <span>Article Data</span>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                class="w-5 h-5 ml-auto"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="1"
                  d="M19 9l-7 7-7-7"
                />
              </svg>
            </div>
            <div
              class="p-4 mt-4 rounded-lg bg-primary-dark"
              v-if="child.showData"
            >
              <div
                class="flex w-full"
                v-for="(articleData, dataIndex) in child.articleData"
                :key="dataIndex"
              >
                <p class="flex-1">{{ articleData.key }}</p>
                <p class="flex-1">{{ articleData.data }}</p>
              </div>
            </div>
          </div>
        </div>
      </template>
    </expandabel-table>
    <div class="flex flex-col items-center w-full">
      <button
        type="button"
        class="flex items-center mr-8 text-lg text-white underline bg-transparent border-none cursor-pointer"
        @click="loadMore()"
        v-if="articleDataLength > this.articleData.length"
      >
        Load more...
      </button>
    </div>
  </wrapper>
</template>

<script>
import ExpandabelTable from "./ExpandabelTable.vue";

export default {
  components: { ExpandabelTable },
  props: {
    articles: Array,
    getStrategy: Function,
    getGroupNames: Function,
  },
  data() {
    return {
      columnsToNotSort: ["name", "articleStrategy"],
      headers: {
        name: "Name",
        articleStrategy: "Strategy",
      },
      articleData: [],
      articleDataLength: 0,
      page: 1,
    };
  },
  beforeMount() {
    this.articleDataLength = this.articles.length;
    this.loadData();
  },
  methods: {
    loadMore() {
      this.page += 1;
      this.loadData();
    },
    loadData() {
      const pageSize = 10;
      const paginatedResult = this.articles
        .slice((this.page - 1) * pageSize, this.page * pageSize)
        .map((article, index) => ({
          id: index + this.page * pageSize,
          name: article.name,
          articleStrategy: this.getStrategy(article.articleStrategy),
          expandableData: {
            externalIdentifier: article.externalIdentifier,
            groupStrategy: article.groupStrategy,
            groupNames: this.getGroupNames(article.groupIds),
            articleData: article.articleData,
            showData: false,
          },
        }));

      this.articleData.push(...paginatedResult);
    },
  },
};
</script>

<style></style>
